import { SET_LIST_SCHOOL_YEAR } from './schoolYearConst';

export function setListSchoolYear(school_year) {
  return {
    type: SET_LIST_SCHOOL_YEAR,
    school_year
  };
}
